// src/store/reducers.js

import { GET_CLASSROOMS, GOT_CLASSROOMS, FETCH_CLASSROOMS_ERROR,GET_MEDIA, GOT_MEDIA, FETCH_MEDIA_ERROR, GET_TRANSCRIPTION, GOT_TRANSCRIPTION, FETCH_TRANSCRIPTION_ERROR, GET_OVERALL_DATA, GOT_OVERALL_DATA, FETCH_OVERALL_DATA_ERROR } from './actionTypes';

const initialState = {
    classrooms: [],
    MediaData:[],
    Transcription:[],
    OverallData: [],
    loading: false,
    error: null,
};

const classroomReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLASSROOMS:
            return { ...state, loading: true, error: null };
        case GOT_CLASSROOMS:
            return { ...state, classrooms: action.payload, loading: false };
        case FETCH_CLASSROOMS_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_MEDIA:
            return { ...state, loading: true, error: null };
        case GOT_MEDIA:
            return { ...state, MediaData: action.payload, loading: false };
        case FETCH_MEDIA_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_TRANSCRIPTION:
            return { ...state, loading: true, error: null };
        case GOT_TRANSCRIPTION:
            return { ...state, Transcription: action.payload, loading: false };
        case FETCH_TRANSCRIPTION_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_OVERALL_DATA:
            return { ...state, loading: true, error: null };
        case GOT_OVERALL_DATA:
            return { ...state, OverallData: action.payload, loading: false };
        case FETCH_OVERALL_DATA_ERROR:
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
};

export default classroomReducer;
